// A test account that started over (lib/testers/startOver) must find THIS
// browser fresh too: the netti chat, the views, the dismissed hints and the walk
// all live in local and session storage, and those are kept per address, so
// the start-over page (innernet.live) cannot reach what the dashboard
// (yours.innernet.live) kept. Each address clears itself, once per start over:
// everything but the auth session's own keys (sb-…), then a stamp so a reload
// keeps what the new run has made.

export const STARTED_OVER_SEEN = 'innernet:started-over-seen'

/** Clear this address's storage if `startedOverAt` is newer than what it last cleared for. True when it cleared. */
export function freshBrowserFor(startedOverAt: string | null | undefined): boolean {
  if (!startedOverAt || typeof window === 'undefined') return false
  try {
    if (localStorage.getItem(STARTED_OVER_SEEN) === startedOverAt) return false
    for (const k of Object.keys(localStorage)) if (!k.startsWith('sb-')) localStorage.removeItem(k)
    try { sessionStorage.clear() } catch { /* private mode */ }
    localStorage.setItem(STARTED_OVER_SEEN, startedOverAt)
    return true
  } catch {
    return false
  }
}
